module.exports = {
    website_name: 'STJK',
    zh_logo_url: 'https://cdn.gda.top/image_after_2019_06/2580/701592276098_.pic_hd.jpg',
    en_logo_url: 'https://cdn.gda.top/image_after_2019_06/2634/441592558999_.pic_hd.jpg',
    ru_logo_url: 'https://cdn.gda.top/image_after_2019_06/3157/oao_logo.png',

    zh_company_organization_group_url: 'https://cdn.gda.top/image_after_2019_06/2617/261592535127_.pic_hd.jpg',
    en_company_organization_group_url: 'https://cdn.gda.top/image_after_2019_06/2633/271592535127_.pic_hd.jpg',
    ru_company_organization_group_url: 'https://cdn.gda.top/image_after_2019_06/3029/ru_company_organization_group_url.png',
    white_zh_logo: 'https://cdn.gda.top/image_after_2019_06/2584/logo_white_zh.png',

    zh_download_banner1: 'https://cdn.gda.top/image_after_2019_06/2819/down_img1_zh.png',
    zh_download_banner2_1: 'https://cdn.gda.top/image_after_2019_06/2820/down_img2_1_zh.png',
    zh_download_banner2_2: 'https://cdn.gda.top/image_after_2019_06/2821/down_img2_2_zh.png',
    zh_download_banner3_1: 'https://cdn.gda.top/image_after_2019_06/2822/down_img3_1_zh.png',
    zh_download_banner3_2: 'https://cdn.gda.top/image_after_2019_06/2823/down_img3_2_zh.png',
    zh_download_banner4: 'https://cdn.gda.top/image_after_2019_06/2851/down_img4_zh.png',

    en_download_banner1: 'https://cdn.gda.top/image_after_2019_06/2825/down_img1_en.png',
    en_download_banner2_1: 'https://cdn.gda.top/image_after_2019_06/2826/down_img2_1_en.png',
    en_download_banner2_2: 'https://cdn.gda.top/image_after_2019_06/2827/down_img2_2_en.png',
    en_download_banner3_1: 'https://cdn.gda.top/image_after_2019_06/2828/down_img3_1_en.png',
    en_download_banner3_2: 'https://cdn.gda.top/image_after_2019_06/2829/down_img3_2_en.png',
    en_download_banner4: 'https://cdn.gda.top/image_after_2019_06/2850/down_img4_en.png',

    ru_download_banner1: 'https://cdn.gda.top/image_after_2019_06/2831/down_img1_ru.png',
    ru_download_banner2_1: 'https://cdn.gda.top/image_after_2019_06/2832/down_img2_1_ru.png',
    ru_download_banner2_2: 'https://cdn.gda.top/image_after_2019_06/2833/down_img2_2_ru.png',
    ru_download_banner3_1: 'https://cdn.gda.top/image_after_2019_06/2834/down_img3_1_ru.png',
    ru_download_banner3_2: 'https://cdn.gda.top/image_after_2019_06/2835/down_img3_2_ru.png',
    ru_download_banner4: 'https://cdn.gda.top/image_after_2019_06/2852/down_img4_ru.png',

    kr_download_banner1: 'https://cdn.gda.top/image_after_2019_06/2837/down_img1_kr.png',
    kr_download_banner2_1: 'https://cdn.gda.top/image_after_2019_06/2838/down_img2_1_kr.png',
    kr_download_banner2_2: 'https://cdn.gda.top/image_after_2019_06/2839/down_img2_2_kr.png',
    kr_download_banner3_1: 'https://cdn.gda.top/image_after_2019_06/2840/down_img3_1_kr.png',
    kr_download_banner3_2: 'https://cdn.gda.top/image_after_2019_06/2841/down_img3_2_kr.png',
    kr_download_banner4: 'https://cdn.gda.top/image_after_2019_06/2855/down_img4_kr.png',

    jp_download_banner1: 'https://cdn.gda.top/image_after_2019_06/2844/down_img1_jp.png',
    jp_download_banner2_1: 'https://cdn.gda.top/image_after_2019_06/2845/down_img2_1_jp.png',
    jp_download_banner2_2: 'https://cdn.gda.top/image_after_2019_06/2846/down_img2_2_jp.png',
    jp_download_banner3_1: 'https://cdn.gda.top/image_after_2019_06/2847/down_img3_1_jp.png',
    jp_download_banner3_2: 'https://cdn.gda.top/image_after_2019_06/2848/down_img3_2_jp.png',
    jp_download_banner4: 'https://cdn.gda.top/image_after_2019_06/2856/down_img4_jp.png',

    zh_img_url: 'https://cdn.gda.top/image_after_2019_06/2973/zh_img.png',
    en_img_url: 'https://cdn.gda.top/image_after_2019_06/2974/en_img.png',
    ru_img_url: 'https://cdn.gda.top/image_after_2019_06/2975/ru_img.png'
}
